import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/motion";

export default function LegalPage({ eyebrow, title, accent, subtitle, updated, sections, testid }) {
  return (
    <div data-testid={testid} className="bg-[#0A0A0A]">
      <PageHero eyebrow={eyebrow} title={title} accent={accent} subtitle={subtitle} />
      <section className="mx-auto max-w-[900px] px-6 py-20 md:px-12 md:py-28">
        {updated && (
          <p className="mb-14 inline-block border border-white/10 px-4 py-2 text-xs uppercase tracking-[0.2em] text-zinc-500">
            Last updated: {updated}
          </p>
        )}
        <div className="flex flex-col gap-14">
          {sections.map((s, i) => (
            <Reveal key={i} delay={0.03 * i}>
              <div data-testid={`legal-section-${i}`}>
                <div className="mb-5 flex items-baseline gap-4">
                  <span className="font-display text-2xl text-teal/50">0{i + 1}</span>
                  <h2 className="font-condensed text-3xl tracking-wide md:text-4xl">{s.h}</h2>
                </div>
                <div className="space-y-4 md:pl-[3rem]">
                  {s.p?.map((para, j) => (
                    <p key={j} className="text-base leading-relaxed text-zinc-400 md:text-lg">
                      {para}
                    </p>
                  ))}
                  {s.list && (
                    <ul className="space-y-3 pt-1">
                      {s.list.map((li, k) => (
                        <li key={k} className="flex gap-3 text-base leading-relaxed text-zinc-400 md:text-lg">
                          <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 bg-teal" />
                          <span>{li}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-16 border-t border-white/10 pt-8 text-zinc-500">
            Questions about this policy? Email{" "}
            <a href="mailto:support@trainovaapp.com" className="text-teal transition-colors hover:text-teal-hover">
              support@trainovaapp.com
            </a>
            .
          </div>
        </Reveal>
      </section>
    </div>
  );
}
